import { BitrixVue, reactive } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { VplRouter } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { CatalogCard } from 'vpl.tas';
import { CheckboxItem } from 'vpl.tas';
import { showCatalogPreloader, hideCatalogPreloader  } from 'vpl.tas';
import { holdCatalogPreloader, releaseCatalogPreloader } from 'vpl.tas';



export const OsnashenieCatalogProducts = {
    components: {
        ItemEditBtns,
        CatalogCard,
        CheckboxItem
    },
    props: {
        structKey: [String, Number]
    },
    updated(){
        this.items = this.struct[this.structKey].componentData.ITEMS;
        this.pagin = this.struct[this.structKey].componentData.PAGIN;
    },
    mounted(){
        this.items = this.struct[this.structKey].componentData.ITEMS;
        this.pagin = this.struct[this.structKey].componentData.PAGIN;

    },
    methods: {
        lazyLoad(link ,append = true){

            link = link.split('#')[0];
            let arRoute = link.split('?');
            let params = 'get_json=Y';
            if(arRoute[1]){
                params += '&' + arRoute[1];
            }

            holdCatalogPreloader();
            $.ajax({
                url: arRoute[0] + '?' + params,
                method: 'GET',
                complete: () => releaseCatalogPreloader(),
                success: (response) => {
                    response = JSON.parse(response);
                    if(append){
                        this.struct[this.structKey].componentData.ITEMS = [...this.items, ...response.struct[this.structKey].componentData.ITEMS];
                    }else{
                        this.struct[this.structKey].componentData.ITEMS = response.struct[this.structKey].componentData.ITEMS;

                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(this.$el).offset().top - 70
                        }, 500);
                    }
                    this.struct[this.structKey].componentData.PAGIN = response.struct[this.structKey].componentData.PAGIN;

                }
            });
        },
    },
    computed: {
        ...mapState(vplSiteStore, ['templateData', 'struct', 'title', 'SITE_TEMPLATE_PATH']),
    },
    template: `
<section v-if="this.struct[this.structKey].componentData.ITEMS && Object.keys(this.struct[this.structKey].componentData.ITEMS).length" class="section">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
					Ассортимент для оснащения {{this.struct[this.structKey].componentData.DESCRIPTION}}
                </h2>
            </div>
        </div>
        <div class="equip__assort">
            <a v-for="item in this.struct[this.structKey].componentData.ITEMS" :href="item.DETAIL_PAGE_URL" class="equip__assort-item">
                <div class="equip__assort-item-img" :class="{'no-photo': item.IMAGE === false}">
                    <img v-if="item.IMAGE !== false" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.IMAGE" :alt="item.NAME" :title="item.NAME">
                    <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME">
                </div>
                <div class="equip__assort-item-title">
                    {{item.NAME}}
                </div>
            </a>
            <div class="content-nav" v-if="this.struct[this.structKey].componentData.PAGIN">
                <ul class="content-nav__list">
                    <template v-for="link in this.struct[this.structKey].componentData.PAGIN">
                        <li v-if="link.type==='left_arrow'" class="content-nav__list-item content-nav__list-item--prev">
                            <a :href="link.link" @click.prevent="lazyLoad(link.link, false)" data-skip="y">
                                <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                            </a>
                        </li>
                        <li v-if="link.type==='number'" :class="{active: link.selected}" class="content-nav__list-item"><a @click.prevent="lazyLoad(link.link, false)" data-skip="y" :href="link.selected ? '#' : link.link">{{ link.text }}</a></li>
                        <li v-if="link.type==='dots'" class="content-nav__list-item"><a @click.prevent="lazyLoad(link.link, false)" data-skip="y" :href="link.link">...</a></li>
                        <li v-if="link.type==='right_arrow'" class="content-nav__list-item content-nav__list-item--next">
                            <a :href="link.link" data-skip="y" @click.prevent="lazyLoad(link.link, false)">
                                <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                            </a>
                        </li>
                    </template>
                </ul>
                <template v-for="link in this.struct[this.structKey].componentData.PAGIN">
                    <a v-if="link.type==='showmore'" href="#" @click.prevent="lazyLoad(link.link)" class="btn btn--border">Показать ещё</a>
                </template>
            </div>
        </div>
    </div>
</section>

    `
}